import {BottomSheet, Button} from '@ds/components';
import {useNavigate} from 'react-router-dom';
import {useAppDispatch} from 'store';
import {resetBranches, setSelectedVendor} from 'store/slices/dashboard/slicer';
import {resetAuth, resetUser} from 'store/slices/login/slicer';
import {unregisterToken} from 'store/slices/notification/thunk';
import {getSelectedVendorFromStorage} from 'utils/Helper';

type LogoutBottomSheetProps = {
  show: boolean;
  onClose: () => void;
};

const LogoutBottomSheet: React.FC<LogoutBottomSheetProps> = ({show, onClose}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    const deviceId = localStorage.getItem('deviceId');
    const storedVendorId = getSelectedVendorFromStorage()?.id;
    const vendorId =
      typeof storedVendorId === 'string' || typeof storedVendorId === 'number'
        ? storedVendorId
        : '0';
    const parsedDeviceId = Number(deviceId);

    if (deviceId && deviceId !== 'undefined' && !Number.isNaN(parsedDeviceId)) {
      void dispatch(unregisterToken({vendor_id: vendorId, device_id: parsedDeviceId}));
    }

    localStorage.removeItem('deviceId');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('isVendor');
    dispatch(resetAuth());
    dispatch(resetUser());
    dispatch(setSelectedVendor(undefined));
    dispatch(resetBranches());
    navigate('/login', {replace: true});
    onClose();
  };

  return (
    <BottomSheet show={show} onClose={onClose} contentStyle={{padding: 16}}>
      <div className="flex flex-col gap-4">
        <p className="text-body-lg-emphasis text-gray-09">آیا برای خروج مطمئن هستید؟</p>
        <div className="flex gap-2">
          <Button fullWidth variant="fill" color="secondary" onClick={onClose}>
            خیر
          </Button>
          <Button fullWidth onClick={handleLogout}>
            بله
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default LogoutBottomSheet;
